
export default {
  paymentschedules: []
}
